/**
 * rune-ts에 빌트인 store 시스템이 없으므로 자체 정의한 단순 Pub-Sub Store.
 * DESIGN.md §4.4 + apps/web/src/lib/rune-lifecycle-notes.md 참조.
 */
export class Store<T> {
  private state: T;
  private listeners = new Set<(state: T, prev: T) => void>();

  constructor(initial: T) {
    this.state = initial;
  }

  get(): T {
    return this.state;
  }

  set(updater: T | ((prev: T) => T)): void {
    const prev = this.state;
    const next = typeof updater === 'function' ? (updater as (p: T) => T)(prev) : updater;
    if (Object.is(next, prev)) return;
    this.state = next;
    for (const fn of this.listeners) fn(next, prev);
  }

  subscribe(fn: (state: T, prev: T) => void): () => void {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  listenerCount(): number {
    return this.listeners.size;
  }
}
